import { router } from '../root.router';

export const navigate = (to: string) => {
  router.navigate(to);
};
